export enum EffectiveSubscriptionState {
  ACTIVE = 'ACTIVE',
  TRIAL = 'TRIAL',
  GRACE_PERIOD = 'GRACE_PERIOD',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  FREE = 'FREE',
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION'
}
